/**
 * Returns a clamped lesson index between 0 and totalLessons - 1.
 * @param {number} targetIndex - The lesson index you want to go to.
 * @param {number} totalLessons - The total number of lessons available.
 * @returns {number} - A safe lesson index within valid bounds.
 */
export function getValidLessonIndex(targetIndex, totalLessons) {
  return Math.max(0, Math.min(targetIndex, totalLessons - 1));
}
